export const dateMask = (value: string): string => {
  return value
      .replace(/\D/g, '')
      .replace(/(\d{1})?(\d{1})?(\d{1})?(\d{1})?(\d{1})?(\d{3})?/, (p0, dayA, dayB, monthA, monthB, yearA, yearB) => {
        let mask = ''
        if (dayA) {
          mask = `${dayA}`;
          if (dayB) mask += `${dayB}`;
          if (monthA) mask += `/${monthA}`;
          if (monthB) mask += `${monthB}`;
          if (yearA) mask += `/${yearA}`
          if (yearB) mask += `${yearB}`
        }
   
        return mask;
      })
      .slice(0, 10);
};